import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballSeasonService } from "../../../../../../commons";
import {
  IMatchStartInfo,
  IMatchStateInfo,
} from "../../../../../../api-services/football/admin/manage-football-season-service";

interface ISeasonMatchStateChange {
  seasonMatchStateChangeResponseStatus: StatusEnum;
}

const initialState: ISeasonMatchStateChange = {
  seasonMatchStateChangeResponseStatus: StatusEnum.Idle,
};

export interface IMatchStateChangeOptions {
  seasonId: number;
  matchId: number;
  stateId: number;
  matchStartInfo: IMatchStateInfo;
  urlParams?: {
    hostTeamId?: number;
  };
}

export const seasonMatchStateChange = createAsyncThunk(
  "manage/seasonMatchStateChange",
  async (options: IMatchStateChangeOptions, thunkAPI) => {
    try {
      const seasonMatchStateChangeResponse = await manageFootballSeasonService.changeSeasonMatchState(
        options.seasonId,
        options.matchId,
        options.stateId,
        options.matchStartInfo,
        options.urlParams
      );
      return seasonMatchStateChangeResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const seasonMatchStateChangeSlice = createSlice({
  name: "seasonMatchStateChange",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(seasonMatchStateChange.pending, (state) => {
        state.seasonMatchStateChangeResponseStatus = StatusEnum.Loading;
      })
      .addCase(seasonMatchStateChange.fulfilled, (state, action) => {
        state.seasonMatchStateChangeResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(seasonMatchStateChange.rejected, (state) => {
        state.seasonMatchStateChangeResponseStatus = StatusEnum.Failed;
      });
  },
});

export default seasonMatchStateChangeSlice.reducer;
